import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { invalidateTimeEntries } from './keys';
import { ITimeEntry } from './types';

export type ReviewTimeEntryVariables =
	| { id: string; action: 'approve' | 'reject'; lastChangedAt: string; comment?: string }
	| { id: string; action: 'reopen'; comment: string };

export const useReviewTimeEntryMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: unknown, variables: ReviewTimeEntryVariables) => void;
	onSuccess?: (data: ITimeEntry, variables: ReviewTimeEntryVariables) => void;
} = {}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ id, action, ...body }: ReviewTimeEntryVariables) =>
			userSession.webServiceHelper.callAsync<ITimeEntry>(`TimeEntry/${encodeURIComponent(id)}/${action}`, 'POST', body),
		onError,
		onSuccess,
		onSettled: () => invalidateTimeEntries(),
	});
};
